module.exports = `
<transition name="slideup">
	<div v-if="dataisload && isopen" id="dialog-market" :class="{active:isopen}" class="dialog-bottom dialog-item">
		<div @click.prevent="closeSelf" class="close-dialog dialog-mask mask" data-target="#dialog-market"></div>
		<div class="dialog-inner">
			<div class="dialog-bottom-content position-relative">
				<a @click.prevent="closeSelf" class="r-lightbox__close" href="#"></a>
				<div class="">
					<div class="">
						<div class="item-detail">
							<div class="item-img float-left">
								<new-image v-if="selected.Images.length!==0" :url="selected.Images[0].Url" :size="'_w310_h389'" :name="alldatas.Name"></new-image>
							</div>
							<div class="item-right shopping-table float-left">
								<div class="item-name text-truncate mb-2">{{alldatas.Name}}</div>
								<div class="item-price h6">								
									<span class="sell-price">NT$ {{alldatas.EventPrice >0 && alldatas.EventPrice < alldatas.SellPrice ?alldatas.EventPrice.toLocaleString(): alldatas.SellPrice.toLocaleString()}}</span>
									<span v-if="alldatas.SellPrice !== alldatas.OriginPrice || alldatas.EventPrice >0" class="origin-price">NT$ {{alldatas.OriginPrice.toLocaleString()}}</span>
								</div>
								<div v-for="(event,index) in alldatas.Events" class="h6 my-2">
								    <span class="">(活動)</span>
									<span>{{event.Name}}</span>
								</div>
								<div class="item-pick mt-5">
									<div class="item-color-wrap">
										<div class="product-color">
											<ul>
												<li @click="changeImg(color.ID)" class="item-color" v-for="(color, index) in alldatas.Colors" :class="{active: color.ID === selected.ID}">
													<a href="javascript:;">
														<img :src="color.PintSizePictureUrl+'?w=20&h=20'">
													</a>
												</li>
											</ul>
										</div>
									</div>
									<div class="item-size-wrap">
										<div class="r-select-radio">
											<ul class="r-select__options">
												<li @click="selectSpec(spec)" v-for="(spec, index) in selected.Specs" :class="{weak: spec.Stock === 0, selected: spec.ID === selectedSpecID, preshow: alldatas.IsPreShow}">
													<a href="javascript:;">
														<span>{{spec.Name}} {{spec.Description}}</span>
													</a>
												</li>
											</ul>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<div class="UiQuantity w-100 bg-white counter">
												<a @click.prevent="reduceCount" class="UiQuantity__btn UiQuantity__btn--minus">–</a>
													<span class="UiQuantity__text">{{counter}}</span>
												<a @click.prevent="addCount(selectedSpec === null ? 1:selectedSpec.Stock)" class="UiQuantity__btn UiQuantity__btn--plus">＋</a>
											</div>
										</div>
										<div class="col">
											<div @click.prevent="addToCart" class="product-buttons m-0">
												<button class="btn-add-cart btn w-100"><span>{{btnDescriptionGenerate}}</span></button>
											</div>
										</div>
									</div>
								</div>
								
							</div>
							<div class="clearfix"></div>
							
						</div>
						
					</div>
				</div>
			</div>			
		</div>
	</div>
</transition>
`;
